import { loader } from 'fetch-tree';
import { getSection } from '../actions/section';
import { selectSection } from '../selectors/section';

export const sectionsLoader = loader({
    id: ids => `/sections/${ids.join(':')}`,
    action(ids) {
        return dispatch => Promise.all(ids.map(id => dispatch(getSection(id))));
    },
    selector: (state, ids) => ids.map(id => selectSection(state, id)),
});

export const sectionLoader = loader({
    id: id => `section-${id}`,
    action: getSection,
    selector: selectSection,
});



// WEBPACK FOOTER //
// ./src/resources/section.js